import { supabase } from "../../supabase";
import toast from "react-hot-toast";

// Helper function to check if API data is duplicate
const isDuplicateApiData = (newApiData, existingHistory) => {
  if (!existingHistory || existingHistory.length === 0) return false;
  
  // Get the most recent entry
  const latestEntry = existingHistory[0];
  if (!latestEntry?.raw_data) return false;
  
  const existingApiData = latestEntry.raw_data;
  
  // Compare key fields that indicate if it's the same data
  const keyFields = [
    'followers', 'posts', 'user_typeScore', 'typeScore', 'language', 'country', 'city'
  ];
  
  // For paid checks, also compare audience analysis data
  if (newApiData.audienceAnalysis && existingApiData.audienceAnalysis) {
    const audienceFields = [
      'genderMtoF', 'birthyearMedian', 'countryArray', 'languageArray', 
      'cityArray', 'audienceType'
    ];
    
    for (const field of audienceFields) {
      const newValue = JSON.stringify(newApiData.audienceAnalysis[field]);
      const existingValue = JSON.stringify(existingApiData.audienceAnalysis[field]);
      if (newValue !== existingValue) return false;
    }
  }
  
  // Compare basic fields
  for (const field of keyFields) {
    if (newApiData[field] !== existingApiData[field]) return false;
  }
  
  return true; // All key fields match, it's a duplicate
};

// Helper function to handle history insertion with duplicate checking
const insertHistoryIfNotDuplicate = async ({ tableName, influencerId, apiData, username, user }) => {
  try {
    // Check for duplicate API data before inserting history
    const { data: existingHistory, error: historyError } = await supabase
      .from(tableName)
      .select("*")
      .eq("influencer_id", influencerId)
      .order("timestamp", { ascending: false });

    if (historyError) {
      console.error(`Error fetching ${tableName}:`, historyError);
      // Continue with inserting new history if we can't fetch existing
    }

    // Check if the new API data is a duplicate of the most recent entry
    const isDuplicate = isDuplicateApiData(apiData, existingHistory);
    
    if (isDuplicate) {
      toast(`${username}: Data identical to previous check - no new history entry created`, { icon: 'ℹ️' });
      return false; // Indicate no new history was created
    } else {
      // Insert history record only if it's not a duplicate
      await supabase.from(tableName).insert({
        influencer_id: influencerId,
        checked_by: user?.id || null,
        timestamp: new Date().toISOString(),
        raw_data: apiData,
      });
      return true; // Indicate new history was created
    }
  } catch (error) {
    console.error(`Error handling history insertion for ${tableName}:`, error);
    throw error;
  }
};
export default insertHistoryIfNotDuplicate;